import { RefObject, useLayoutEffect, useState } from "react";

type AccessLogScrollElement = {
  element: HTMLElement | null;
  margin: number;
};

/*
 * 가상 목록의 스크롤 주체와 시작 위치
 * 웹뷰(body.open-taap)와 웹 모두 window 가 아니라 .base-layout-container 가 스크롤하므로
 * window 기준이면 첫 화면 뒤 행이 그려지지 않음. 이름으로 찍지 않고 실제로 스크롤하는 조상을 찾음 (UserDelete 와 같은 판정)
 */
const useAccessLogScrollElement = (listRef: RefObject<HTMLElement>, enabled: boolean): AccessLogScrollElement => {
  const [scroll, setScroll] = useState<AccessLogScrollElement>({ element: null, margin: 0 });

  // 목록이 그려진 뒤에야 잴 수 있으므로 enabled 가 바뀌면 다시 측정
  useLayoutEffect(() => {
    if (!enabled) return;

    const measure = () => {
      const list = listRef.current;
      if (!list) return;

      let element: HTMLElement | null = list.parentElement;
      while (element) {
        if (/(auto|scroll)/.test(window.getComputedStyle(element).overflowY)) break;
        element = element.parentElement;
      }

      // 스크롤하는 조상이 없으면 문서 자체가 스크롤
      const scroller = element || (document.scrollingElement as HTMLElement | null);
      if (!scroller) return;

      // 목록 위 헤더와 기간 필터 높이만큼이 가상 좌표의 출발점
      const margin = list.getBoundingClientRect().top - scroller.getBoundingClientRect().top + scroller.scrollTop;

      setScroll((prev) => (prev.element === scroller && prev.margin === margin ? prev : { element: scroller, margin }));
    };

    measure();
    window.addEventListener("resize", measure);

    return () => window.removeEventListener("resize", measure);
  }, [enabled, listRef]);

  return scroll;
};

export default useAccessLogScrollElement;
